export const NetworkContextName = "Binance Test Network";
export const ACTIVE_NETWORK = 4;
export const countDownDate = new Date("Dec 31, 2021 23:59:59").getTime();
export const RPC_URL = "https://data-seed-prebsc-1-s3.binance.org:8545/";
export const baseURI =
  "https://ipfs.io/ipfs/QmdP6VwefyuVTz3k7n2AcPv16HxJ3fz3zN23vAkJY9S6ST";
export const StakingContracAddress =
  "0x3cf754fa1aA2f9174a6dDf5F9360621239771Be1";
